(function () {
  function init() {
    document.querySelectorAll('.sg-landing[data-sg-upgraded]').forEach(function (root) {
      if (root.dataset.sgPresentationReady) return;
      root.dataset.sgPresentationReady = 'true';
      var media = root.querySelector('.sg-autoHero');
      var slides = Array.from(media.querySelectorAll('.sg-autoSlide'));
      var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var current = 0, timer = null, visible = false;
      function stop() { window.clearInterval(timer); timer = null; }
      function preload() { slides[(current + 1) % slides.length].querySelector('img').loading = 'eager'; }
      function advance() {
        if (!root.isConnected) { stop(); return; }
        var next = (current + 1) % slides.length;
        var image = slides[next].querySelector('img');
        if (!image.complete || !image.naturalWidth) return;
        current = next;
        slides.forEach(function (slide, index) {
          slide.classList.toggle('is-active', index === current);
          slide.setAttribute('aria-hidden', String(index !== current));
        });
        preload();
      }
      function sync() {
        stop();
        if (!motion.matches && !document.hidden && visible && root.isConnected) {
          preload(); timer = window.setInterval(advance, 6500);
        }
      }
      var observer = new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; sync(); }, { threshold: .15 });
      observer.observe(media);
      motion.addEventListener('change', sync);
      document.addEventListener('visibilitychange', sync);
      var resizers = [];
      root.querySelectorAll('.sg-gallery').forEach(function (gallery) {
        var track = gallery.querySelector('.sg-track');
        var prev = gallery.querySelector('[data-prev]');
        var next = gallery.querySelector('[data-next]');
        var count = gallery.querySelector('.sg-count');
        if (!track || !prev || !next) return;
        function gap() { return parseFloat(getComputedStyle(track).gap) || 0; }
        function step() { return track.children[0].getBoundingClientRect().width + gap(); }
        function update() {
          var unit = step();
          var first = Math.max(0, Math.round(track.scrollLeft / unit));
          var shown = Math.max(1, Math.floor((track.clientWidth + gap() + 1) / unit));
          var last = Math.min(track.children.length, first + shown);
          prev.disabled = track.scrollLeft < 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
          count.textContent = (first + 1) + (last > first + 1 ? '–' + last : '') + ' / ' + track.children.length;
        }
        function move(direction) {
          var unit = step();
          track.scrollTo({ left: Math.max(0, (Math.round(track.scrollLeft / unit) + direction) * unit), behavior: motion.matches ? 'instant' : 'smooth' });
        }
        prev.addEventListener('click', function () { move(-1); });
        next.addEventListener('click', function () { move(1); });
        track.addEventListener('scroll', update, { passive: true });
        track.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        var resize = new ResizeObserver(update); resize.observe(track); resizers.push(resize);
        update();
      });
      function unload(event) {
        if (!event.target.contains(root)) return;
        stop(); observer.disconnect(); resizers.forEach(function (resize) { resize.disconnect(); });
        motion.removeEventListener('change', sync);
        document.removeEventListener('visibilitychange', sync);
        document.removeEventListener('shopify:section:unload', unload);
      }
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
